export enum UnitOfMeasureTypes {
  Quantity = 'QTY',
  Each = 'EA',
  Kilogram = 'Kg',
  Gram = 'GRM',
  Libra = 'LBR',
  Litre = 'LTR',
  GallonImperial = 'GLI',
  GallonLiquid = 'GLL',
  CMT = 'CMT',
  INH = 'INH',
  FAH = 'FAH',
  CEL = 'CEL',
}

export enum UomText {
  QTY = 'QTY',
  EA = 'Unit',
  Kg = 'kg',
  KGM = 'kg',
  GRM = 'g',
  LTR = 'L',
  LBR = 'lb',
  GLI = 'gal',
  GLL = 'gal',
  CMT = 'cm',
  INH = 'in',
  FAH = '°F',
  CEL = '°C',
}
